import "./Contact.css";
const ContactBox = (props) => {
  return (
    <div className="box me-auto ms-auto">
      <div className="box-head row ">
        <div className="col-3 icon">{props.icon}</div>
        <div className="col-9 text-center">
          <h4 className="text-capitalize">{props.btn}</h4>
          <p className="text-black-50">{props.num}</p>
        </div>
        <a
          href=""
          className="m-auto btn-action text-center btn-primary btn w-75"
        >
          {props.btn} now
        </a>
      </div>
    </div>
  );
};

export default ContactBox;
